/**
 * Fusionne les messages selon la priorité :
 * catalogue distant (langue courante) > catalogue source (anglais) > clé.
 * L'anglais reste ainsi le fallback permanent pour toute clé manquante.
 */
export function mergeMessages(sourceMessages, remoteMessages) {
    const result = { ...sourceMessages };
    for (const [key, value] of Object.entries(remoteMessages)) {
        result[key] = value;
    }
    return result;
}
//# sourceMappingURL=merge.js.map